<template>
  <div class="stage-content backup-container">
    <div class="custom-tab">
      <div class="custom-tab-header">
        <div>
          <span class="title">Backups</span>
        </div>
        <div class="text-right relative search-input-container">
          <b-input v-model="searchText" class="mb-2 mr-sm-2 mb-sm-0 search-input" id="search_text" type="text" placeholder="Search sites" />
          <div class="search-icon-container">
            <magnifier-icon class="icon-default search-icon"></magnifier-icon>
          </div>
        </div>
        <div class="text-right action-btn-cont">
          <b-btn variant="primary px-3" @click="showCreateBackup">Create a New Backup</b-btn>
        </div>
      </div>
      <div class="custom-tab-body nofooter">
        <div>
          <b-row v-for="(site,siteId) in backups" :key="siteId">
            <b-col class="backup-col">
              <b-row class="backup-item-row p-0">
                <b-col v-b-toggle="'accordion-' + siteId" class="backuprow">
                  <b-row>
                    <div class="col-3 site-count-name">
                      <span class="item-count">{{site.totalCount}}</span>
                      <span class="site-name">{{site.siteName}}</span>
                    </div>
                    <div class="col">
                      <span class="category-label">Repository</span>
                    </div>
                    <div class="col">
                      <span class="category-label">Type</span>
                    </div>
                    <div class="col">
                      <span class="category-label">Size</span>
                    </div>
                    <div class="col-3">
                      <span class="category-label">Date</span>
                    </div>
                    <div class="col">
                    </div>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="detail-col">
                  <b-collapse :id="'accordion-'+siteId" role="tabpanel" class="item-checkbox-details" style="width:100%">
                    <div>
                      <div v-for="(backup,type) in site.backups" :key="type" class="backup-detail-item-cont">
                        <div class="backup-detail-wrapper">
                          <div class="backup-type">
                            {{type | backupType}}
                          </div>
                          <div v-for="(backupTypes, index) in backup" :key="index">
                            <b-row v-for="(backupItem,index) in backupTypes" :key="index" class="backup-detail-item-row backup-item-row">
                              <b-col cols="3" class="backup-name">
                                {{backupItem.backupNameDisplay}}
                              </b-col>
                              <b-col class="repo">
                                <cloud-icon class="icon-default cloud"></cloud-icon>
                                <span class="ml-1">{{backupItem.repository}}</span>
                              </b-col>
                              <b-col class="type">
                                <files-db-icon v-if="backupItem.what=='full'" class="icon-default filesdb"></files-db-icon>
                                <files-icon v-if="backupItem.what=='files'" class="icon-default filesdb"></files-icon>
                                <db-icon v-if="backupItem.what=='db'" class="icon-default filesdb"></db-icon>
                                <span class="ml-1">{{backupItem.what | filetypes}}</span>
                              </b-col>
                              <b-col class="size">
                                <disk-icon class="icon-default disk"></disk-icon>
                                <span class="ml-1">{{backupItem.size}}
                                </span>
                              </b-col>
                              <b-col class="time" cols="3">
                                <clock-simple-icon class="icon-default clocksimple"></clock-simple-icon>
                                <span class="ml-1">{{backupItem.time}}
                                </span>
                              </b-col>
                              <b-col class="d-flex justify-content-between">
                                <a class="action-btn" @click="showRestorePrompt(backupItem)" v-b-tooltip.hover title="Restore">
                                  <restore-icon class="icon-default restore"></restore-icon>

                                </a>
                                <a class="action-btn" @click="downloadBackup(backupItem)" v-b-tooltip.hover title="Download">
                                  <download-icon class="icon-default download"></download-icon>
                                </a>
                                <a class="action-btn" @click="showDeletePrompt(backupItem)" v-b-tooltip.hover title="Delete">
                                  <delete-icon class="icon-default delete-icon"></delete-icon>
                                </a>
                              </b-col>
                            </b-row>

                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

        </div>
        <empty-placeholder v-if="Object.keys(backups).length===0" v-bind="placeholderProps" @onBtnClick="showCreateBackup"></empty-placeholder>
      </div>
    </div>
    <restore-backup :backup="currentBackup" ref="restorebackupmodal"></restore-backup>
    <download-backup :backup="currentBackup" ref="downloadbackupmodal"></download-backup>
    <delete-modal @yes="deleteBackup" ref="deletemodal"></delete-modal>
    <create-backup ref="createBackup"></create-backup>
  </div>
</template>
<script>
import MagnifierIcon from '../../assets/lens.svg';
import CloudIcon from '../../assets/cloud.svg';
import FilesDbIcon from '../../assets/filesdb.svg';
import FilesIcon from '../../assets/files.svg';
import DbIcon from '../../assets/db.svg';
import DiskIcon from '../../assets/disk.svg';
import ClockSimpleIcon from '../../assets/clocksimple.svg';
import RestoreIcon from '../../assets/restore.svg';
import DownloadIcon from '../../assets/download.svg';
import DeleteIcon from '../../assets/delete.svg';

import RestoreBackup from '../modals/RestoreBackup';
import DownloadBackup from '../modals/DownloadBackup';
import DeleteModal from '../modals/DeleteModal';
import CreateBackup from '../protect/CreateBackup';

import EmptyPlaceholder from '../Common/EmptyPlaceholder';
import _ from 'lodash';
export default {
  name: 'Backups',
  components: {
    MagnifierIcon,
    CloudIcon,
    FilesDbIcon,
    DiskIcon,
    ClockSimpleIcon,
    RestoreIcon,
    DownloadIcon,
    DeleteIcon,
    FilesIcon,
    DbIcon,
    RestoreBackup,
    DownloadBackup,
    DeleteModal,
    CreateBackup,
    EmptyPlaceholder
  },
  filters: {
    filetypes: value => {
      if (!value) return '';
      value = value.toString();
      if (value === 'full') {
        return 'Files & DB';
      }
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    backupType: value => {
      if (value === 'schedule') {
        return 'Schedule Backups';
      }
      if (value === 'manual') {
        return 'Manual Backups';
      }
      if (value === 'others') {
        return 'Other Backups (Backups from deleted schedules & backups from reconnected sites are shown below)';
      }
      return '';
    }
  },
  data() {
    return {
      searchText: '',
      entity: {},
      currentBackup: {},
      placeholderProps: {
        text:
          "No backups found here. \n\nYou can create a new backup by clicking on the 'Create a New Backup' button above.",
        type: 'neutral'
      }
    };
  },
  mounted() {
    //this.showCreateBackup();
    this.loadBackups();
  },
  computed: {
    getSelectedSites() {
      return this.$store.getters.selectedSites;
    },
    getBackups() {
      return this.$store.getters.getBackups;
    },
    backups() {
      let selectedSites = this.getSelectedSites;
      let allBackups = this.getBackups;
      let backups = {};

      _.each(allBackups, (backup, siteId) => {
        let site = _.find(selectedSites, { siteID: siteId });
        if (
          site &&
          site.name &&
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        ) {
          backups[siteId] = {};
          backups[siteId] = backup;
          backups[siteId].siteName = site.name;
        }
      });
      return backups;
    }
  },
  methods: {
    loadBackups() {
      let payload = {};
      payload.requiredData = {
        getSitesBackupsV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.$store.commit('SET_BACKUPS', response.data.getSitesBackupsV3);
      });
    },
    showRestorePrompt(backupItem) {
      this.currentBackup = backupItem;
      this.$refs.restorebackupmodal.$refs.restorebackupmodal.show();
    },
    downloadBackup(backupItem) {
      if (_.isObject(backupItem.downloadURL)) {
        this.currentBackup = backupItem;
        this.$refs.downloadbackupmodal.$refs.downloadbackupmodal.show();
      } else {
        return window.open(backupItem.downloadURL, '_blank');
      }
    },
    showDeletePrompt(backupItem) {
      this.currentBackup = backupItem;
      this.$refs.deletemodal.$refs.deletemodal.show();
    },
    deleteBackup() {
      this.$refs.deletemodal.$refs.deletemodal.hide();
      let payload = {
        requiredData: {
          getSitesBackupsV3: 1
        },
        action: 'removeBackup'
      };
      let taskName = this.currentBackup.task_name;
      payload.args = {
        params: {
          taskName: taskName,
          resultID: this.currentBackup.referenceKey
        },
        siteIDs: [this.currentBackup.siteID]
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        // this.$store.commit('SET_BACKUPS', response.data.getSitesBackupsV3);
      });
    },
    showCreateBackup() {
      this.$refs.createBackup.$refs.createBackupModal.show();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/backups.vue